module.exports = __webpack_public_path__ + "images/space_insight_2020.png";